module.exports = {
  en: {
    anticlockwise: 'anticlockwise',
    '貌似示例不存在': "Sorry, demo doesn't exist",
    'wechat emotions': 'wechat emotions',
    'Default format: YYYY-MM-DD': 'Default format: YYYY-MM-DD',
    Format: 'Format',
    'Start time': 'Start time',
    Placeholder: 'Placeholder',
    'Please select': 'Please select',
    'Set min-year and max-year': 'Set min-year and max-year',
    'Years after 2000': 'Years after 2000',
    'Specified template text in Chinese': 'Specified template text in Chinese',
    'Show center button and clear the value': 'Show center button and clear the value',
    'Show center button to set date to today': 'Show center button to set date to today',
    Birthday: 'Birthday',
    Chinese: 'Chinese',
    'Click me': 'Click me',
    'Custom trigger slot': 'Custom trigger slot',
    'Define range of hours': 'Define range of hours',
    'Working hours: 09-18': 'Working hours: 09-18',
    'Set start-date and end-date': 'Set start-date and end-date',
    'Click to change value to: 2017-11-11': 'Click to change value to: 2017-11-11',
    'Format display value': 'Format display value',
    'Toggle format': 'Toggle format',
    'Custom minute list: every 15 minutes': 'Custom minute list: every 15 minutes',
    'Custom hour list': 'Custom hour list',
    'Use prop: show.sync (vue^2.3) to control visibility': 'Use prop: show.sync (vue^2.3) to control visibility',
    'Used as a plugin': 'Used as a plugin',
    'Set default-selected-value to 2017-11-11': 'Set default-selected-value to 2017-11-11',
    'Prop: compute-hours-function': 'Prop: compute-hours-function',
    'Prop: compute-days-function': 'Prop: compute-days-function',
    'Toggle readonly': 'Toggle readonly',
    'Set value: 2017-11-11': 'Set value: 2017-11-11',
    'Set end-date only': 'Set end-date only',
    'default type = img': 'default type = img',
    'type = canvas': 'type = canvas',
    'current url': 'current url',
    'current fgColor': 'current fgColor',
    'next step': 'next step',
    done: 'done',
    processing: 'processing',
    end: 'end',
    'step 1': 'step 1',
    'step 2': 'step 2',
    'step 3': 'step 3',
    Horizontal: 'Horizontal',
    'Honrizontal with no gutter': 'Honrizontal with no gutter',
    Vertical: 'Vertical',
    'Vertical with no gutter': 'Vertical with no gutter',
    'Grid support (12 columns)': 'Grid support (12 columns)',
    'Flexible grid': 'Flexible grid',
    'Automatic countdown': 'Automatic countdown',
    Manually: 'Manually',
    Start: 'Start',
    'Simple card with header and content': 'Simple card with header and content',
    'My wallet': 'My wallet',
    Point: 'Point',
    Coupon: 'Coupon',
    'Gift card': 'Gift card',
    Cash: 'Cash',
    'With footer': 'With footer',
    'Product details': 'Product details',
    More: 'More',
    'Custom content': 'Custom content',
    'Use header slot and content slot': 'Use header slot and content slot',
    'Show loading': 'show loading (close in 2s)',
    'Show delay loading': 'show loading delay after 1s',
    'No loading text': 'No loading text',
    'Use in cell': 'Use in cell',
    'Custom template': 'Custom template',
    'Date: 2018-08-01': 'Date: 2018-08-01',
    'Popover on top': 'Popover on top',
    'Popover on bottom': 'Popover on bottom',
    'Popover on left': 'Popover on left',
    'Popover on right': 'Popover on right',
    'Popover with scroll height': 'Popover with scroll height',
    placeholder: 'placeholder',
    'hide counter': 'hide counter',
    'used with input': 'used with input',
    title: 'title',
    'Type something': 'Type something',
    autosize: 'autosize',
    'set height=200': 'set height=200',
    'Start date': 'Start date',
    'End date': 'End date',
    'Control days': 'Control days',
    'Disable past': 'Disable past',
    'Disable future': 'Disable future',
    'Disable weekend': 'Disable weekend',
    'Show last month': 'Show last month',
    'Show next month': 'Show next month',
    'Always show 6 rows': 'Always show 6 rows',
    'If not, the height of calendar would change': 'If not, the height of calendar would change',
    'Highlight weekend': 'Highlight weekend',
    'Control navs': 'Control navs',
    'Hide header': 'Hide header',
    'Hide week list': 'Hide week list',
    'Change week list': 'Change week list',
    'Replace text': 'Replace text',
    'Replace date text': 'Replace date text',
    'Set time to': 'Set time to',
    'Custom every day cell': 'Custom every day cell',
    'Add custom contents in day cell': 'Add custom contents in day cell',
    'Add red dot for dates with number 8': 'Add red dot for dates with number 8',
    'We can render a list of calendars order by month': 'We can render a list of calendars order by month',
    'Switch the type': 'Switch the type',
    'List of content with image': 'List of content with image',
    'type:text': 'type:text',
    'type:cancel': 'type:cancel',
    'type:success': 'type:success',
    'type:warn': 'type:warn',
    'time:1s': 'time:1s',
    'long text': 'long text',
    success: 'success',
    'show me code': 'show me code',
    'prop:text': 'prop:text',
    default: 'default',
    'As a plugin(>=v0.1.3)': 'As a plugin(>=v0.1.3)',
    position: 'position',
    'Switch the position of labels': 'Switch the position of labels',
    'Select first option': 'Select first option',
    'Select first two': 'Select first two',
    'Select the remaining values': 'Select the remaining values',
    'Preselect China and Japan (disabled)': 'Preselect China and Japan (disabled)',
    'Set max=2': 'Set max=2',
    'Set random order': 'Set random order',
    'Option Array with key and value (key must be string)': 'Option Array with key and value (key must be string)',
    'Option is Object with InlineDesc': 'Option is Object with InlineDesc',
    'Async list': 'Async list',
    'Set max=1 (radio mode)': 'Set max=1 (radio mode)',
    Reference: 'Reference',
    'See also': 'See also',
    Default: 'Default',
    Quantity: 'Quantity',
    listen: 'listen to on-change events (printed on console)',
    'set width=100px': 'set width=100px',
    'set step=0.5': 'set step=0.5',
    'set value=1, min=-5 and max=8': 'set value=1, min=-5 and max=8',
    'fillable = true': 'fillable = true',
    'use with other group elements': 'use with other group elements',
    'Switch Component': 'Switch Component',
    'round style': 'round style',
    'I have bottom line': 'I have bottom line',
    'Hi, you got a new message': 'Hi, you got a new message',
    'small dot': 'small dot',
    'Pull Up to Refresh': 'Pull Up to Refresh',
    'Loading...': 'Loading...',
    'A Horizontal Scroller without Scrollbar': 'A Horizontal Scroller without Scrollbar',
    'A Horizontal Scroller with Scrollbar': 'A Horizontal Scroller with Scrollbar',
    'A Horizontal Scroller without bounce effect': 'A Horizontal Scroller without bounce effect',
    'A Vertical Scroller': 'A Vertical Scroller',
    'A Vertical Scroller with scrollbar': 'A Vertical Scroller with scrollbar',
    'show another list': 'show another list',
    Button: 'Button',
    'event:on-scroll-bottom': 'event:on-scroll-bottom',
    'set bar-active-color': 'set bar-active-color',
    'pre-select China(disabled)': 'pre-select China(disabled)',
    'Basic Usage': 'Basic Usage',
    'Set value as TODAY': 'Set value as TODAY',
    'Show popup header': 'Show popup header',
    'Multiple dates': 'Multiple dates',
    'Format multiple dates': 'Format multiple dates',
    'Empty value': 'Empty value',
    Toggle: 'Toggle',
    'Toggle show-input': 'Toggle show-input',
    Toggle_android: 'Toggle_android',
    'Are you sure?': 'Are you sure?',
    'Confirm deleting the item': 'Confirm deleting the item',
    'Please input something': 'Please input something',
    'Plugin usage': 'Plugin usage',
    Show: 'Show',
    'closeOnConfirm=false': 'closeOnConfirm=false',
    'Set default input value': 'Set default input value',
    'Call prompt by using plugin': 'Call prompt by using plugin',
    'showCancelButton=false': 'showCancelButton=false',
    Today: 'Today',
    'This Week': 'This Week',
    'This Month': 'This Month',
    Articles: 'Articles',
    Products: 'Products',
    'Articles sync': 'Articles sync',
    'Products sync': 'Products sync',
    'All Messages': 'All Messages',
    'New Messages': 'New Messages',
    'Red Dot': 'Red Dot',
    'Use v-model to set selected item': 'Use v-model to set selected item',
    'Used in a Cell': 'Used in a Cell',
    'Single digit': 'Single digit',
    'Big Number': 'Big Number',
    'Red dot': 'Red dot',
    'Show Me': 'Show Me',
    'Use as a plugin': 'Use as a plugin',
    Congratulations: 'Congratulations',
    'Your Message is sent successfully~': 'Your Message is sent successfully~',
    'Do you agree?': 'Do you agree?',
    'Will auto close in 3s': 'Will auto close in 3s',
    'Radio: no default value': 'Radio: no default value',
    '潘': 'A',
    '闲': 'B',
    '邓': 'C',
    '小': 'D',
    '驴': 'E',
    '白': 'White',
    '富': 'Rich',
    '美': 'Beautiful',
    '花跟叶': 'Red',
    '鸟与树': 'Blue',
    '我和你': 'Green',
    '全套礼品装': 'Yellow',
    Checkbox: 'Checkbox',
    'Checkbox with max limit 2': 'Checkbox with max limit 2',
    'Current value is': 'Current value is',
    'Default value 2': 'Default value 2',
    'Custom styles': 'Custom styles',
    'Select color': 'Select color',
    'Used in a popup': 'Used in a popup',
    'A real world radio example': 'A real world radio example',
    'A real world checkbox example': 'A real world checkbox example',
    good: 'good',
    nice: 'nice',
    awesome: 'awesome',
    'Radio: object value': 'Radio: object value',
    'Checkbox: object value': 'Checkbox: object value',
    'My Account': 'My Account',
    Protected: 'Protected',
    'Use is-link to show arrow': 'Use is-link to show arrow',
    Notifications: 'Notifications',
    Enabled: 'Enabled',
    Privacy: 'Privacy',
    General: 'General',
    'Use slot for complicated content': 'Use slot for complicated content',
    'Slot content': 'Slot content',
    "Hi, I'm Vux.": "Hi, I'm Vux.",
    'is-link is set to true automatically when link exists': 'is-link is set to true automatically when link exists',
    'Go to Radio Demo': 'Go to Radio Demo',
    'Go to Demo': 'Go to Demo',
    'Http link': 'Http link',
    Money: 'Money',
    Collapse: 'Collapse',
    'Title 001': 'Title 001',
    'Title 002': 'Title 002',
    'Title 003': 'Title 003',
    Animated: 'Animated',
    Withdraw: 'Withdraw',
    Messages: 'Messages',
    'hide on clicking mask': 'hide on clicking mask',
    'use .sync': 'use .sync',
    'disable background scrolling': 'disable background scrolling',
    'long long content': 'long long content',
    'custom dialog style': 'custom dialog style',
    'show toast': 'show toast',
    'please select': 'please select',
    'Normal usage, the first one is selected without setting default value': 'Normal usage, the first one is selected without setting default value',
    'Asynchronous loading and dynamic change of data': 'Asynchronous loading and dynamic change of data',
    'Set data 1': 'Set data 1',
    'Set data 2': 'Set data 2',
    'Set data 3': 'Set data 3',
    'With default value': 'With default value',
    'Two-way data binding': 'Two-way data binding',
    'Multi cols in non chained-mode': 'Multi cols in non chained-mode',
    'Five columns': 'Five columns',
    'Locations in chained-mode': 'Locations in chained-mode',
    'Text corresponding to the value': 'Text corresponding to the value',
    '3 cols data but only show 2 cols': '3 cols data but only show 2 cols',
    'select address': 'select address',
    'value map': 'value map',
    'default false': 'default false',
    'default true': 'default true',
    disabled: 'disabled',
    'html title': 'html title',
    'switch red': '<span style="color:red">I am Red.</span>',
    'Prevent auto closing': 'Prevent auto closing',
    'Close me': 'Close me',
    'Deleted~': 'Deleted~',
    'Slot: header': 'Slot: header',
    'Android Theme': 'Android Theme',
    'Show cancel menu': 'Show cancel menu',
    'Menu as tips': 'Menu as tips',
    'Prevent closing when clicking mask': 'Prevent closing when clicking mask',
    'Share to friends': 'Share to friends',
    'Share to timeline': 'Share to timeline',
    'Take Photo': 'Take Photo',
    'Choose from photos': 'Choose from photos',
    'Actionsheet header': 'Are you sure?<br/><span style="color:#666;font-size:12px;">Once deleted, you will never find it.</span>',
    '<span style="color:red">Delete</span>': '<span style="color:red">Delete</span>',
    'Array menu': 'Array menu',
    '北京': 'Beijing',
    '上海': 'Shanghai',
    '广州': 'Guangzhou',
    '深圳': 'Shenzhen',
    '天津': 'Tianjin',
    '西安': 'Xian',
    '重庆': 'Chongqing',
    '杭州': 'Hangzhou',
    '南京': 'Nanjing',
    '武汉': 'Whuhan',
    '成都': 'Chendu',
    '美食': 'Food',
    '电影': 'Movie',
    '酒店': 'Hotel',
    '休闲娱乐': 'Entertainment',
    '火锅': 'Hot pot',
    '旅游': 'Travel',
    '代金券': 'Coupon',
    KTV: 'KTV',
    '对比不做处理的1px边框': 'Original Ugly borders',
    cancel: 'cancel',
    'Please select your card': 'Please select your card',
    'used with Popup': 'used with Popup',
    'Card 1': 'Card 1',
    'Card 2': 'Card 2',
    'Card 3': 'Card 3',
    'Card 4': 'Card 4',
    'Used within cell': 'Used within cell',
    'Current value': 'Current value',
    'Set 2017-11-11': 'Set 2017-11-11',
    'Set 2016-08-08': 'Set 2016-08-08',
    'Format 2019-10-23 10': 'Format 2019-10-23 10',
    'Show popup with datetime-view': 'Show popup with datetime-view',
    loading: 'loading',
    Total: 'Total',
    '$1024': '$1024',
    Apple: 'Apple',
    Banana: 'Banana',
    Fish: 'Fish',
    'In progress': 'In progress',
    Paid: 'Paid',
    Shipped: 'Shipped',
    Delivered: 'Delivered',
    Done: 'Done',
    Choose: 'Choose',
    'daterange-format': 'YYYY/MM/DD',
    'Default usage': 'Default usage',
    'Used in a cell': 'Used in a cell',
    News: 'News',
    'Async data': 'Async data',
    'Yeah! You make it': 'Yeah! You make it',
    'Msg description': 'Msg description',
    'Primary button': 'Primary button',
    'Secondary button': 'Secondary button',
    Fav: 'Fav',
    Delete: 'Delete',
    'JavaScript is the best language': 'JavaScript is the best language',
    'now enabled': 'now enabled',
    'now disabled': 'now disabled',
    'set Enabled': 'set Enabled',
    'set Disabled': 'set Disabled',
    'open left menu': 'open left menu',
    'open right menu': 'open right menu',
    'close menu': 'close menu',
    'threshold = 0.5': 'threshold = 0.5',
    Yes: 'Yes',
    Right: 'Right',
    Ignore: 'Ignore',
    Grid: 'Grid',
    'Go to Cell': 'Go to Cell',
    'Custom col': 'Custom col',
    '正在加载': 'Loading',
    '暂无数据': 'The End',
    '付款金额': 'Total',
    '标题标题': 'Item Title',
    '商品': 'Product',
    '很长很长的名字很长很长的名字很长很长的名字很长很长的名字很长很长的名字': 'Long Long Long Long Long Long Long Long Long Long Long Long Content',
    '名字名字名字': 'Name Name',
    '电动打蛋机': 'Item title',
    '辅助操作': 'Info',
    '操作': 'Action',
    '点击事件': 'Click Event',
    '跳转到首页': 'Homepage',
    'A cell without title': 'A cell without title',
    header_tit: 'Focuslight Bidding',
    reg_msg: 'Registration Successful',
    login_txt: 'Sign in now',
    'Sign in now': 'Sign in now',
    'Focuslight Bidding': 'Focuslight Bidding',
    'Registration Successful': 'Registration Successful',
    "Don't have an account?": "Don't have an account?"
  },
  'zh-CN': {
    anticlockwise: '逆时针',
    '貌似示例不存在': '貌似示例不存在',
    'wechat emotions': '微信表情列表',
    'Default format: YYYY-MM-DD': '默认格式：YYYY-MM-DD',
    Format: '格式',
    'Start time': '开始时间',
    Placeholder: '提示文字',
    'Please select': '请选择日期',
    'Set min-year and max-year': '设置开始和结束年份',
    'Years after 2000': '2000年以后的时间',
    'Specified template text in Chinese': '自定义中文显示模板',
    'Show center button and clear the value': '显示中间的清除按钮',
    'Show center button to set date to today': '显示中间的设置日期为今天的按钮',
    Birthday: '生日',
    Chinese: '中文',
    'Click me': '点我',
    'Custom trigger slot': '自定义触发内容',
    'Define range of hours': '限定小时范围',
    'Working hours: 09-18': '工作时间为 09-18',
    'Set start-date and end-date': '设置开始时间和结束日期',
    'Click to change value to: 2017-11-11': '设置时间为 2017-11-11',
    'Format display value': '格式化显示',
    'Toggle format': '切换时间格式',
    'Custom minute list: every 15 minutes': '自定义分钟列表（每15分钟）',
    'Custom hour list': '定义小时列表',
    'Use prop: show.sync (vue^2.3) to control visibility': '使用 prop: show.sync 控制显示(vue^2.3)',
    'Used as a plugin': '插件形式调用',
    'Set default-selected-value to 2017-11-11': '设置默认选中值为 2017-11-11',
    'Prop: compute-hours-function': '自定义小时列表生成逻辑',
    'Prop: compute-days-function': '自定义日期列表生成逻辑',
    'Toggle readonly': '切换 readonly',
    'Set value: 2017-11-11': '设置时间为2017-11-11',
    'Set end-date only': '只设置结束时间',
    'default type = img': '默认类型为 img，可以在微信里长按识别',
    'type = canvas': '类型为 canvas',
    'current url': '当前url',
    'current fgColor': '当前颜色',
    'next step': '下一步',
    done: '确定',
    processing: '进行中',
    end: '结束',
    'step 1': '步骤1',
    'step 2': '步骤2',
    'step 3': '步骤3',
    Horizontal: '水平',
    'Honrizontal with no gutter': '水平无间隙',
    Vertical: '垂直',
    'Vertical with no gutter': '垂直无间隙',
    'Grid support (12 columns)': '网格（12列）',
    'Flexible grid': '弹性网格',
    'Automatic countdown': '自动倒计时',
    Manually: '手动模式',
    Start: '开始',
    'Simple card with header and content': '带有标题和内容的简单卡片',
    'My wallet': '我的钱包',
    Point: '京豆',
    Coupon: '京东券',
    'Gift card': '京东卡/E卡',
    Cash: '七天待还',
    'With footer': '带有 footer 的卡片',
    'Product details': '商品详情',
    More: '查看更多',
    'Custom content': '自定义内容',
    'Use header slot and content slot': '使用 header slot 和 content slot',
    'Show loading': '显示loading (2s后关闭)',
    'Show delay loading': '延时1s后显示',
    'No loading text': '无提示文字',
    'Use in cell': '在 cell 中使用',
    'Custom template': '自定义模版',
    'Date: 2018-08-01': '日期：2018-08-01',
    'Popover on top': '上方出现',
    'Popover on bottom': '下方出现',
    'Popover on left': '左边出现',
    'Popover on right': '右边出现',
    'Popover with scroll height': '滚动条',
    placeholder: '占位',
    'hide counter': '不显示计数器',
    'used with input': '和input一起使用',
    title: '标题',
    'Type something': '随便写点什么',
    autosize: '自动高度',
    'set height=200': '设置高度为200像素',
    'Start date': '开始日期',
    'End date': '结束日期',
    'Control days': '控制日期',
    'Disable past': '禁止选择未来的日期',
    'Disable future': '禁止选择未来时间',
    'Disable weekend': '禁止选择周末日期',
    'Show last month': '显示上个月',
    'Show next month': '显示下个月',
    'Always show 6 rows': '固定显示6行',
    'If not, the height of calendar would change': '否则，日历的高度会发生改变',
    'Highlight weekend': '高亮周末',
    'Control navs': '控制导航部分',
    'Hide header': '隐藏日历头部',
    'Hide week list': '隐藏星期列表',
    'Change week list': '切换星期列表',
    'Replace text': '更换文本',
    'Replace date text': '替换日期文本',
    'Set time to': '设置为',
    'Custom every day cell': '自定义日期单元格',
    'Add custom contents in day cell': '在日期单元格中添加自定义内容',
    'Add red dot for dates with number 8': '为带有数字8的日期添加红点',
    'We can render a list of calendars order by month': '按月份顺序渲染一系列日历',
    'Switch the type': '切换样式',
    'List of content with image': '图文组合列表',
    'type:text': 'type为text',
    'type:cancel': 'type为cancel',
    'type:success': 'type为success',
    'type:warn': 'type为警告',
    'time:1s': '显示时间1s',
    'long text': '很长的文字',
    success: '成功啦~',
    'show me code': 'Talk is cheap, show me the code.',
    'prop:text': '设置text',
    default: '默认',
    'As a plugin(>=v0.1.3)': '插件形式调用',
    position: '位置',
    'Switch the position of labels': '切换 label 位置',
    'Select first option': '选择第1个值',
    'Select first two': '选择前两个值',
    'Select the remaining values': '选择剩下值',
    'Preselect China and Japan (disabled)': '默认选中 China 和 Japan (禁用操作)',
    'Set max=2': '最多可选中2个',
    'Set random order': '打乱选项顺序',
    'Option Array with key and value (key must be string)': '使用 Object 类型的选项列表，key 必须为字符串',
    'Option is Object with InlineDesc': '包含 inlineDesc 属性的 Object 类型选项列表',
    'Async list': '异步选项列表',
    'Set max=1 (radio mode)': 'max=1（单选模式）',
    Reference: '相关',
    'See also': '参见',
    Default: '默认',
    Quantity: '数量',
    listen: '监听 on-change 事件，在调试窗口中输出',
    'set width=100px': '设置宽度为100px',
    'set step=0.5': '设置步长为0.5',
    'set value=1, min=-5 and max=8': '设置值为1，最小值为-5，最大值为8',
    'fillable = true': '设置可以输入',
    'use with other group elements': '和其他group子元素一起使用',
    'Switch Component': 'Switch 组件',
    'round style': '圆形按钮',
    'I have bottom line': '我是有底线的',
    'Hi, you got a new message': '新消息',
    'small dot': '小点',
    'Pull Up to Refresh': '上拉刷新',
    'Loading...': '努力加载中',
    'A Horizontal Scroller without Scrollbar': '不带滚动条的水平 scroller',
    'A Horizontal Scroller with Scrollbar': '显示滚动条的水平 scroller',
    'A Horizontal Scroller without bounce effect': '没有边缘回滚效果的水平 scroller',
    'A Vertical Scroller': '竖向 scroller',
    'A Vertical Scroller with scrollbar': '显示滚动条的竖向 scroller',
    'show another list': '改变显示的内容',
    Button: '按钮',
    'event:on-scroll-bottom': '检查是否滚动到底部',
    'set bar-active-color': '设置bar颜色',
    'pre-select China(disabled)': '默认值 China(禁用操作)',
    'Basic Usage': '基本使用',
    'Set value as TODAY': '设置时间为今天',
    'Show popup header': '显示 popup 头部',
    'Multiple dates': '多选',
    'Format multiple dates': '格式化表单值',
    'Empty value': '清空值',
    Toggle: '显示/隐藏',
    'Toggle show-input': '显示Prompt',
    Toggle_android: '安卓风格',
    'Are you sure?': '确定咩？',
    'Confirm deleting the item': '操作提示',
    'Please input something': '请输入些什么',
    'Plugin usage': '插件形式调用',
    Show: '显示',
    'closeOnConfirm=false': '阻止自动关闭',
    'Set default input value': '设置默认输入文字',
    'Call prompt by using plugin': '插件形式调用prompt',
    'showCancelButton=false': '隐藏取消按钮',
    Today: '今天',
    'This Week': '本周',
    'This Month': '本月',
    Articles: '文章',
    Products: '商品',
    'Articles sync': '文章同步',
    'Products sync': '商品同步',
    'All Messages': '所有消息',
    'New Messages': '新消息',
    'Red Dot': '红点',
    'Use v-model to set selected item': '使用 v-model 设置当前选中项',
    'Used in a Cell': '在 Cell 组件里使用',
    'Single digit': '个位数',
    'Big Number': '多位数',
    'Red dot': '红点',
    'Show Me': '显示',
    'Use as a plugin': '以插件方式调用',
    Congratulations: '恭喜',
    'Your Message is sent successfully~': '消息已成功发送',
    'Do you agree?': '同意不？',
    'Will auto close in 3s': '3秒后关闭',
    'Radio: no default value': '单选，默认不选中任何项',
    '潘': '潘',
    '闲': '闲',
    '邓': '邓',
    '小': '小',
    '驴': '驴',
    '白': '白',
    '富': '富',
    '美': '美',
    '花跟叶': '花跟叶',
    '鸟与树': '鸟与树',
    '我和你': '我和你',
    '全套礼品装': '全套礼品装',
    Checkbox: '多选',
    'Checkbox with max limit 2': '多选，最多只能选2个',
    'Current value is': '当前值为',
    'Default value 2': '默认值 2',
    'Custom styles': '自定义样式',
    'Select color': '选择颜色',
    'Used in a popup': 'Popup 组件中使用',
    'A real world radio example': '单选常见例子',
    'A real world checkbox example': '多选常见例子',
    good: '好',
    nice: '很好',
    awesome: '特别好',
    'Radio: object value': '单选：object类型',
    'Checkbox: object value': '多选：object类型',
    'My Account': '我的账号',
    Protected: '保护中',
    'Use is-link to show arrow': '使用 is-link 显示右边箭头',
    Notifications: '通知',
    Enabled: '已开启',
    Privacy: '隐私',
    General: '通用',
    'Use slot for complicated content': '使用slot显示复杂内容',
    'Slot content': 'slot 内容',
    "Hi, I'm Vux.": '你好哇，感谢关注 Vux',
    'is-link is set to true automatically when link exists': '当设有 link 属性时，会自动产生箭头效果，无需再设置 is-link',
    'Go to Radio Demo': '前往Radio页面',
    'Go to Demo': '前往Demo页面',
    'Http link': '站外链接',
    Money: '余额',
    Collapse: '折叠',
    'Title 001': '标题一',
    'Title 002': '标题二',
    'Title 003': '标题三',
    Animated: '动画效果',
    Withdraw: '提现',
    Messages: '消息',
    'hide on clicking mask': '点击遮罩自动关闭',
    'use .sync': '使用 .sync',
    'disable background scrolling': '背景不可滚动',
    'long long content': '很长很长的内容',
    'custom dialog style': '自定义 dialog 容器样式',
    'show toast': '显示 toast',
    'please select': '请选择',
    'Normal usage, the first one is selected without setting default value': '默认，不设置默认值时选中第一个',
    'Asynchronous loading and dynamic change of data': '异步加载及动态改变数据',
    'Set data 1': '设置数值1',
    'Set data 2': '设置数值2',
    'Set data 3': '设置数值3',
    'With default value': '设置默认值时',
    'Two-way data binding': '双向绑定',
    'Multi cols in non chained-mode': '非联动多列',
    'Five columns': '五列',
    'Locations in chained-mode': '地区联动',
    'Text corresponding to the value': '选中值所对应的文字',
    '3 cols data but only show 2 cols': '3列的数据，只显示两列',
    'select address': '选择地址',
    'value map': '值转换 map',
    'default false': '默认 false',
    'default true': '默认 true',
    disabled: '禁用',
    'html title': '使用html设置title',
    'switch red': '<span style="color:red">我是红色</span>',
    'Prevent auto closing': '不自动关闭',
    'Close me': '点我关闭',
    'Deleted~': '删除成功',
    'Slot: header': '使用 header slot',
    'Android Theme': '安卓风格',
    'Show cancel menu': '显示取消菜单',
    'Menu as tips': '显示提示文字',
    'Prevent closing when clicking mask': '点击遮罩区域不自动关闭',
    'Share to friends': '分享给朋友',
    'Share to timeline': '分享到朋友圈',
    'Take Photo': '拍照',
    'Choose from photos': '从相册选择',
    'Actionsheet header': '确定咩?<br/><span style="color:#666;font-size:12px;">删除后就无法撤消了哦</span>',
    '<span style="color:red">Delete</span>': '<span style="color:red">删除</span>',
    'Array menu': '使用数组定义菜单',
    '北京': '北京',
    '上海': '上海',
    '广州': '广州',
    '深圳': '深圳',
    '天津': '天津',
    '西安': '西安',
    '重庆': '重庆',
    '杭州': '杭州',
    '南京': '南京',
    '武汉': '武汉',
    '成都': '成都',
    '美食': '美食',
    '电影': '电影',
    '酒店': '酒店',
    '休闲娱乐': '休闲娱乐',
    '火锅': '火锅',
    '旅游': '旅游',
    '代金券': '代金券',
    KTV: 'KTV',
    '对比不做处理的1px边框': '对比不做处理的1px边框',
    cancel: '取消',
    'Please select your card': '请选择银行卡',
    'used with Popup': 'Popup 中使用',
    'Card 1': '招商银行',
    'Card 2': '工商银行',
    'Card 3': '农业银行',
    'Card 4': '增加银行卡',
    'Used within cell': '在cell中使用',
    'Current value': '选中值',
    'Set 2017-11-11': '设置为 2017-11-11',
    'Set 2016-08-08': '设置为 2016-08-08',
    'Format 2019-10-23 10': '时间格式设置为 2019-10-23 10',
    'Show popup with datetime-view': '显示弹窗样式',
    loading: '加载中',
    Total: '合计',
    '$1024': '￥1024',
    Apple: '苹果',
    Banana: '香蕉',
    Fish: '鱼肉',
    'In progress': '进行中',
    Paid: '已付款',
    Shipped: '已发货',
    Delivered: '待收货',
    Done: '完成',
    Choose: '选择',
    'daterange-format': 'YYYY年MM月DD日',
    'Default usage': '默认',
    'Used in a cell': '在 cell 中使用',
    News: '公告',
    'Async data': '异步数据',
    'Yeah! You make it': '操作成功',
    'Msg description': '内容详情，可根据实际需要安排，如果换行则不超过规定长度，居中展现<a href="javascript:void(0);">文字链接</a>',
    'Primary button': '推荐操作',
    'Secondary button': '辅助操作',
    Fav: '收藏',
    Delete: '删除',
    'JavaScript is the best language': 'JavaScript 是最好的语言',
    'now enabled': '当前可操作',
    'now disabled': '当前不可操作',
    'set Enabled': '设置可操作',
    'set Disabled': '设置不可操作',
    'open left menu': '打开左菜单',
    'open right menu': '打开右菜单',
    'close menu': '关闭菜单',
    'threshold = 0.5': '设置滑动阙值为 0.5',
    Yes: '是的',
    Right: '正确',
    Ignore: '忽略',
    Grid: '九宫格',
    'Go to Cell': '跳转到Cell',
    'Custom col': '自定义列',
    '正在加载': '正在加载',
    '暂无数据': '暂无数据',
    '付款金额': '付款金额',
    '标题标题': '标题标题',
    '商品': '商品',
    '很长很长的名字很长很长的名字很长很长的名字很长很长的名字很长很长的名字': '很长很长的名字很长很长的名字很长很长的名字很长很长的名字很长很长的名字',
    '名字名字名字': '名字名字名字',
    '电动打蛋机': '电动打蛋机',
    '辅助操作': '辅助操作',
    '操作': '操作',
    '点击事件': '点击事件',
    '跳转到首页': '跳转到首页',
    'A cell without title': '不带标题的 cell',
    header_tit: '炬光采购竞价',
    reg_msg: '注册成功',
    login_txt: '立即登录',
    'Sign in now': '立即登录',
    'Focuslight Bidding': '炬光采购竞价',
    'Registration Successful': '注册成功',
    "Don't have an account?": '没有账号?'
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/locales/components.yml
// module id = 5oa3
// module chunks = 12